export default __webpack_public_path__ + "static/media/logo.a9440f7f.svg";